<template>
  <div class="modal fade" tabindex="-1"
       aria-hidden="true"
       :id="propId"
       :data-bs-backdrop="propStatic === true ? 'static' : ''"
       :data-bs-keyboard="propStatic === true ? 'false' : ''"
       :class="this.classSize"
       :aria-labelledby="propId + 'Label'">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header" :class="propModalHeaderClass" v-if="propModalHeaderHide !== true">
          <slot name="header">
            <h6 class="modal-title" :id="`${propId}Label`">
              <slot name="title">IMPETUS</slot>
              <span class="ms-1 fw-light">
                <slot name="subtitle"></slot>
              </span>
            </h6>
            <span class="ms-2">
              <slot name="next_to_title"></slot>
            </span>
          </slot>
          <slot name="close_modal">
            <button type="button" v-if="!propDisableCloseButtonHeader" class="btn-close" @click="closeModal"
                    aria-label="Close"></button>
          </slot>
        </div>
        <div class="modal-body">
          <slot></slot>
        </div>
        <div class="modal-footer" v-if="propModalFooterHide !== true">
          <slot name="footer"></slot>
          <button type="button"
                  data-bs-dismiss="modal"
                  v-if="!propDisableCloseButtonFooter"
                  class="btn btn-secondary" @click="closeModal">
            <i class="bi bi-x-lg pe-1"/>{{ $t('buttons.close') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Modal} from "bootstrap";

export default {
  name: 'ModalWindow',
  emits: ['onShowModal', 'onCloseModalClick'],
  props: {
    propModalHeaderHide: Boolean,
    propModalFooterHide: Boolean,
    propModalHeaderClass: String,
    propId: String,
    propStatus: Boolean,
    propSize: String,
    propIsOpen: Boolean,
    propDisableCloseButtonFooter: {
      type: Boolean,
      default: false,
    },
    propDisableCloseButtonHeader: {
      type: Boolean,
      default: false,
    },
    /***
     * Set it to true to avoid the closing of the modal
     * when clicking outside or with the escape key
     ***/
    propStatic: Boolean
  },
  watch: {
    //Changing the property from outside will trigger the show/hide of modal
    propStatus(newValue, oldValue) {
      switch (newValue) {
        case true:
          this.showModal();
          break;
        case false:
          this.closeModal();
          break;
      }
    }
  },
  data() {
    return {
      openOnMount: this.propIsOpen
    };
  },
  mounted() {
    if (this.openOnMount)
      this.showModal();
  },
  methods: {
    showModal() {
      let modalObj = this.modalObject;
      if (modalObj !== null) {
        modalObj.show();
        this.$emit('onShowModal')
      }
    },
    closeModal() {
      let modalObj = this.modalObject;
      if (modalObj !== null) {
        modalObj.hide();
        this.$emit('onCloseModalClick')
      }
    },
  },
  computed: {
    classSize() {
      let classSize = '';

      switch (this.propSize) {
        case 'sm':
        case 'lg':
        case 'xl':
          classSize = 'modal-' + this.propSize;
          break;
      }
      return classSize;
    },
    modalObject() {
      //Show modal
      let objDom = document.getElementById(this.propId);
      return objDom !== null && objDom !== undefined ? Modal.getOrCreateInstance(objDom) : null;
    },
  }
};
</script>